import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http, util } from "../../../_helpers";
import { format } from "date-fns";


export const AdminSubscriptionsEdit = () => {
  const [loading, setLoading] = useState(false);

  const { state } = useLocation();
  const [data, setData] = useState<any>(state);
  const navigate = useNavigate();
  console.log(data.endDate)
  const onChange = (key: any, value: any) => {
    setData({ ...data, [key]: value });
    console.log(key, value);
  };

  const onSubmit = async () => {
    setLoading(true);
    console.log("AVANT",data.endDate);
    const res = await http.patch(
      encodeURI('/companies/admin/subscriptions/update'),
      { ...data }
    );
    if (res.code === 200) {
      console.log(res.data.endDate)
      navigate(-1);
    } else {
      alert("Une erreur est survenue ! Merci de reéssayer.");
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!state) {
      navigate("/admin/administrateurs");
    }
  }, []);
  if (!state) {
    return <div />;
  }
  return (
    <div>
      <h4 className="text-muted mb-4">Gestion des abonnements </h4>
      <div className="row mb-4">
        <div className="col-md-12">
          <div className="card border-0 rounded-0">
            <div className="card-title mb-1 p-3">
              {!loading && <h5>Modifier la date d'expiration d'un abonnement</h5>}
              {loading && <h5 className="text-muted">Chargement en cours</h5>}
            </div>
            <div className="card-body">
              {!loading && (
                <form>
                 
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="date_of_birth">Expiration</label>
                        <input
                          type="string"
                          placeholder="JJ-MM-AAAA HH:MM:SS"
                          className="form-control rounded-0"
                          id="date_of_birth"
                          value={data.endDate}
                          onChange={(e) =>
                            onChange("endDate", e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => onSubmit()}
                    className="btn btn-lightning rounded-0 mb-2 mr-2"
                  >
                    Enregistrer
                  </button>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="btn btn-outline-lightning rounded-0 mb-2"
                  >
                    Retour
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
